import { amenitiesService } from "@/services/amenities";
import { Amenity } from "@/services/amenities/types";
import { useCallback, useState } from "react";

export function useAmenities() {
  const [amenities, setAmenities] = useState<Amenity[] | null>(null);
  const [isLoading, setIsLoading] = useState(false);

  const handleSearchAmenities = useCallback(async () => {
    setIsLoading(true);
    try {
      const response = await amenitiesService.getInventoryAmenities();

      setAmenities(response.amenities);
      return response.amenities;
    } catch (error) {
      console.error(error);
      setAmenities(null);
    } finally {
      setIsLoading(false);
    }
  }, []);

  return {
    amenities,
    handleSearchAmenities,
    isLoading,
  };
}
